import React from 'react';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
const CMP = (props: Partial<CustomIconComponentProps>) => (
  <svg viewBox="0 0 30 30" {...props}>
    <rect id="矩形_1082" data-name="矩形 1082" width="30" height="30" fill="none" />
    <g id="menu_2_1" data-name="menu (2) 1" transform="translate(-1 -1)">
      <path
        id="路径_6249"
        data-name="路径 6249"
        d="M17.375,25.75H4.625a1.625,1.625,0,0,1,0-3.25h12.75a1.625,1.625,0,1,1,0,3.25Z"
        fill="rgba(0,0,0,0.5)"
      />
      <path
        id="路径_6250"
        data-name="路径 6250"
        d="M27.375,17.625H4.625a1.625,1.625,0,0,1,0-3.25h22.75a1.625,1.625,0,1,1,0,3.25Z"
        fill="rgba(0,0,0,0.5)"
      />
      <path
        id="路径_6251"
        data-name="路径 6251"
        d="M27.375,9.5H4.625a1.625,1.625,0,0,1,0-3.25h22.75a1.625,1.625,0,1,1,0,3.25Z"
        fill="rgba(0,0,0,0.5)"
      />
    </g>
  </svg>
);

export default CMP;
